import { readState } from "@/__main__/app-state.mjs";
import getData from "@/__main__/get-data.mjs";
import {
  FactionBE,
  GameMode,
  MapRE,
  SearchParamsEnum,
} from "@/game-eft/constants/constants.mjs";
import fetchPlayerSeasonStat from "@/game-eft/fetches/season-stats.mjs";
import { MapMarkerValidate } from "@/game-eft/models/static.mjs";
import type { LiveGame } from "@/game-eft/utils/actions.mjs";
import * as API from "@/game-eft/utils/api.mjs";
import { getLatestMapVersion } from "@/game-eft/utils/map-data.mjs";
import { getLocalProfile } from "@/game-eft/utils/utils-in-game.mjs";
import { devWarn } from "@/util/dev.mjs";

export default async function fetchData(_, searchParams: URLSearchParams) {
  const liveGame: LiveGame | null = readState.eft.liveGame;
  const profile = getLocalProfile(liveGame);
  const mapREName = liveGame?.gameStart?.location;
  const mapName = MapRE?.[mapREName] ?? mapREName;
  const accountId: string | undefined =
    profile?.account_id || readState.settings.lastLoggedInIdByGame.eft;
  if (!accountId) {
    // This isn't exactly an error if the user is a guest launching EFT
    devWarn(
      "EFT in game page failed to fetch player season stat because you lack an account id",
    );
    return;
  }

  const requiredPromises: Promise<unknown>[] = Object.keys(FactionBE).map(
    (faction) =>
      fetchPlayerSeasonStat({
        profileId: accountId,
        gameMode:
          GameMode[searchParams.get(SearchParamsEnum.GameMode)] ??
          GameMode.DEFAULT,
        faction: faction as FactionBE,
      }).catch(() => {
        // We attempt fetch all faction stats, regardless if the user has them or not, which might throw an error
      }),
  );

  const mapVersion = getLatestMapVersion(mapName, true);

  requiredPromises.push(
    getData(API.getMapMarkers(mapName), MapMarkerValidate, [
      "eft",
      "maps",
      "markers",
      mapName,
      mapVersion,
    ]),
  );

  await Promise.all(requiredPromises);
}
